/**
 * @flow
 * @author: Chinmaya
 */

import styled from 'react-emotion'

const Button = styled('button')`
  &:active,
  &:focus {
    outline: none;
  }
`

export default Button
